<template>
  <tr>
    <td class="pa-3 d-sm-table-cell d-print-table-cell fixed-row" />
    <td
      v-for="filter in validFilters"
      :key="filter.field"
      class="pa-3 d-sm-table-cell d-print-table-cell fixed-row"
    >
      <!-- TEXT -->
      <v-text-field
        v-if="filter.type === 'text'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        type="text"
        @keyup.enter="resetToFirstPage"
        hide-details
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData(filter.field)"
      />

      <!-- SELECT -->
      <v-select
        v-else-if="filter.type === 'select'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        :items="filter.items"
        item-text="text"
        item-value="value"
        @change="resetToFirstPage"
        clearable
        hide-details
        dense
      />
      <!-- AUTOCOMPLETE -->
      <v-autocomplete
        v-else-if="filter.type === 'autocomplete'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        :items="filter.items"
        :item-text="filter.itemText || 'text'"
        :item-value="filter.itemValue || 'value'"
        :search-input.sync="filter.searchInput"
        :loading="filter.loading"
        @change="resetToFirstPage"
        clearable
        hide-selected
        hide-details
        dense
      />

      <DateRangeFilter
        v-else-if="filter.type === 'date-range'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        :text-field-props="{ dense: true, prependInnerIcon: 'mdi-calendar' }"
        :include-today="true"
        @input="updateDateRange(filter)"
      />

      <!-- DATE -->
      <v-menu
        v-else-if="filter.type === 'date'"
        v-model="filter.menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :label="filter.label"
            v-model="filter.formatted"
            v-bind="attrs"
            v-on="on"
            @blur="updateDateValue(filter.field, filter.formatted)"
            clearable
            hide-details
            dense
            @click:clear="clearFilterData(filter.field)"
          />
        </template>
        <v-date-picker
          v-model="searchData[filter.field]"
          no-title
          :max="today"
          scrollable
          @input="closeMenu(filter.field)"
        />
      </v-menu>
    </td> 
  </tr>
</template>

<script>
import { formatDate, parseDate } from '@/lib/helpers';
import DateRangeFilter from '../DateRangeField';


export default {
  name: 'BodyFilterView',
  components: {
    DateRangeFilter,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    search: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    autoSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      suppressWatch: false,
    };
  },
  computed: {
    today() {
      return new Date().toLocaleDateString('sv-SE');
    },
    searchData: {
      get() {
        return this.search;
      },
      set(val) {
        this.$emit('update:search', val);
      },
    },
    validFilters() {
      return this.filters.filter(f => f.field !== '');
    }
  },
  watch: {
    filters: {
      handler() {
        this.filters.forEach((filter) => {
          if (filter.type === 'date') {
            this.$watch(
              () => this.searchData[filter.field],
              (val) => {
                if (!this.suppressWatch) {
                  this.$set(filter, 'formatted', formatDate(val));
                  this.resetToFirstPage();
                }
              }
            );
          }

        });
      },
      immediate: true,
    },
  },
  methods: {
    updateDateRange(filter) {
      const val = this.searchData[filter.field];
      if (Array.isArray(val) && val.length === 2) {
        this.$set(filter, 'formatted', `${val[0]} - ${val[1]}`);
      } else {
        this.$set(filter, 'formatted', '');
      }
      this.resetToFirstPage();
    },


    resetToFirstPage() {
      this.$emit('update:options', {
        ...this.options,
        page: 1,
      });

      if (this.autoSearch) {
        this.$emit('getDataParent');
      }
    },
    getDataManual() {
      this.$emit('getDataParent');
    },
    clearFilterData(field) {
      this.suppressWatch = true;
      this.searchData[field] = '';
      const f = this.filters.find((data) => data.field === field);
      if (f && f.type === 'date') f.formatted = '';
      this.$nextTick(() => {
        this.suppressWatch = false;
        this.resetToFirstPage();
      });
    },
    updateDateValue(field, formattedValue) {
      const parsed = parseDate(formattedValue);
      if (parsed) {
        this.searchData[field] = parsed;
        this.resetToFirstPage();
      }
    },
    closeMenu(field) {
      const f = this.filters.find((value) => value.field === field);
      if (f) this.$set(f, 'menu', false);
    },
  },
};
</script>
